// const EMPLEADOS_FOTOS="http://192.168.1.15/~ernesto/FunFarallones/encuestas/empleados_fotos/";
const EMPLEADOS_FOTOS="https://www.fundacionclubfarallones.org/encuestas/empleados_fotos/";
export default EMPLEADOS_FOTOS;